import { combineReducers, compose, applyMiddleware, createStore } from "redux";
import { stateFreezer } from "../reducerEnhancers/stateFreezer";

// #region Reducer

// #region Core Reducer
import { uiReducer } from "../reducers/ui.reducer";
import { notificationsReducer } from "../reducers/notification.reducer";
// #endregion Core Reducer

// #region App Reducer
import contextReducer from "../reducers/identity.reducer";
import languageReducer from "../reducers/language.reducer";
// #endregion App Reducer

// #endregion Reducer

// #region Middleware

// #region Core Middleware
import { apiMiddleware } from "../middleware/core/api.middleware";
import { actionSplitterMiddleware } from "../middleware/core/actionSplitter.middleware";
import { notificationMiddleware } from "../middleware/core/notification.middleware";
import { loggerMiddleware } from "../middleware/core/logger.middleware";
// #endregion Core Middleware

// #region App Middleware
import { languageMiddleware } from "../middleware/app/language.middleware";
// #endregion App Middleware

// #endregion Middleware

// shape the state structure
const rootReducer = combineReducers({
  ui: uiReducer,
  notification: notificationsReducer,
  lang: languageReducer,
});

// create the feature middleware array
const featureMiddleware = [languageMiddleware];

// create the core middleware array
const coreMiddleware = [
  actionSplitterMiddleware,
  apiMiddleware,
  notificationMiddleware,
  loggerMiddleware,
];

// compose the middleware with additional (optional) enhancers,
// DevTools.instrument() will enable dev tools integration
const enhancer = compose(
  applyMiddleware(...featureMiddleware, ...coreMiddleware)
);

// create and configure the store
const store = createStore(stateFreezer(rootReducer), {}, enhancer);

export default store;
